<mat-form-field [ngClass]="{'full-width': props.fullWidth}">
	<mat-label>{{props.label}}</mat-label>

	<mat-chip-set #chipList>
		<mat-chip class="linq-chip" *ngFor="let item of selectedItems" (removed)="remove(item)">
			{{ props.displaySelectedFunc(item) }}
			<mat-icon matChipRemove>close</mat-icon>
		</mat-chip>

		<input #inputRef type="text" matInput [formControl]="itemControl" [formlyAttributes]="field" [readonly]="props.readonly"
			[matAutocomplete]="autoComplete" [matChipInputFor]="chipList">
		<mat-icon matPrefix>search</mat-icon>
	</mat-chip-set>
	<mat-error>{{getErrorMessage()}}</mat-error>

	<mat-autocomplete #autoComplete="matAutocomplete" (closed)="resetInput()">
		<mat-option *ngIf="(noRecordsFound$|async); else SelectAll" disabled>No records found</mat-option>
		<ng-template #SelectAll>
			<mat-option *ngIf="props.hasAllOption" (click)="toggleSelectAll()">
				<mat-pseudo-checkbox [state]="state">
				</mat-pseudo-checkbox>
				Select All
			</mat-option>
		</ng-template>
		<mat-option [ngClass]="{'multi-lines': hasSecondLine}" *ngFor="let item of filteredItems$|async" [value]="selectedItems"
			(click)="optionClicked($event, item);">
			<mat-checkbox [checked]="item.Selected" (change)="toggleSelection(item)" (click)="$event.stopPropagation()">
				{{ displayFn(item) }}
			</mat-checkbox>
			<p class="line-two" *ngIf="hasSecondLine">{{ displayFn2(item) }}</p>
		</mat-option>
	</mat-autocomplete>
</mat-form-field>

<ng-container *ngIf="props.displayDetailed">
	<div class="selected-details" *ngFor="let item of selectedItems">
		<div [innerHtml]="props.detailedTemplate(item)">
		</div>
		<div>
			<button (click)="remove(item)" mat-icon-button color="primary" aria-label="Remove">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</ng-container>
